import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { iif, of } from 'rxjs';
import { isObservable, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { SamwinAcdExtensionStateSelectors } from 'src/app/store/samwin/samwin-acd-extension/samwin-acd-extension.selectors';
import { SamwinAcdExtensionState } from 'src/app/store/samwin/samwin-acd-extension/samwin-acd-extension.state';
import { SessionState } from 'src/app/store/session/session.state';
@Pipe({
   name: 'acdCurrentDevice$',
})
export class AcdCurrentDevicePipe implements PipeTransform {
   constructor(private store: Store) {}

   transform(acdLine: string | Observable<string>, userId: number | Observable<number>): Observable<string> {
      let acdLine$: Observable<string>;
      let userId$: Observable<number>;
      let acdCurrentDevice$: Observable<string>;
      if (isObservable(acdLine)) {
         acdLine$ = acdLine;
      } else {
         acdLine$ = of(acdLine);
      }
      if (isObservable(userId)) {
         userId$ = userId;
      } else {
         userId$ = of(userId);
      }
      acdCurrentDevice$ = this.store.select(SamwinAcdExtensionStateSelectors.getCurrentDeviceAddress);
      const sessionUserId = this.store.selectSnapshot(SessionState.getAuthenticatedUserId);
      return userId$.pipe(
         switchMap((agentId) =>
            iif(
               () => agentId === sessionUserId,
               acdCurrentDevice$.pipe(switchMap((device) => of(device.toString()))),
               acdLine$.pipe(switchMap((device) => of(device.toString())))
            )
         )
      );
   }
}
